/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{height:100%;width:100%}.splitter-container[_ngcontent-%COMP%]{height:100%}.as-horizontal[_ngcontent-%COMP%] > .as-split-gutter[_ngcontent-%COMP%]{height:auto!important}[_nghost-%COMP%]   .as-split-area[_ngcontent-%COMP%]{overflow-x:auto;overflow-y:hidden!important}[_nghost-%COMP%]   .as-horizontal[_ngcontent-%COMP%]     .as-split-gutter{cursor:-webkit-grab!important;cursor:grab!important}[_nghost-%COMP%]   .as-split-area[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]{position:relative;height:100%;overflow:hidden}"];
export { styles as styles };
